var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerLight80(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19211_77797",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 0C41.3807 0 42.5 1.11929 42.5 2.5V20C42.5 21.3807 41.3807 22.5 40 22.5C38.6193 22.5 37.5 21.3807 37.5 20V2.5C37.5 1.11929 38.6193 0 40 0Z",
    fill: "#000001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 57.5C41.3807 57.5 42.5 58.6193 42.5 60V77.5C42.5 78.8807 41.3807 80 40 80C38.6193 80 37.5 78.8807 37.5 77.5V60C37.5 58.6193 38.6193 57.5 40 57.5Z",
    fill: "#000001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0004 5.35885C61.1961 6.04921 61.6058 7.57818 60.9155 8.77392L52.1655 23.9294C51.4751 25.1251 49.9461 25.5348 48.7504 24.8444C47.5547 24.1541 47.145 22.6251 47.8354 21.4294L56.5854 6.27392C57.2757 5.07818 58.8047 4.6685 60.0004 5.35885Z",
    fill: "#000001"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2504 55.1553C32.4461 55.8457 32.8558 57.3746 32.1655 58.5704L23.4155 73.7258C22.7251 74.9215 21.1961 75.3312 20.0004 74.6409C18.8047 73.9505 18.395 72.4215 19.0854 71.2258L27.8354 56.0704C28.5257 54.8746 30.0547 54.4649 31.2504 55.1553Z",
    fill: "#000001"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6451 20.0001C75.3355 21.1958 74.9258 22.7248 73.7301 23.4152L58.5746 32.1652C57.3789 32.8555 55.8499 32.4458 55.1596 31.2501C54.4692 30.0544 54.8789 28.5254 56.0746 27.835L71.2301 19.085C72.4258 18.3947 73.9548 18.8044 74.6451 20.0001Z",
    fill: "#000001"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8405 48.7501C25.5308 49.9458 25.1211 51.4748 23.9254 52.1652L8.76995 60.9152C7.57422 61.6055 6.04524 61.1958 5.35489 60.0001C4.66453 58.8044 5.07422 57.2754 6.26995 56.585L21.4254 47.835C22.6211 47.1447 24.1501 47.5544 24.8405 48.7501Z",
    fill: "#000001"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5 40C57.5 38.6193 58.6193 37.5 60 37.5H77.5C78.8807 37.5 80 38.6193 80 40C80 41.3807 78.8807 42.5 77.5 42.5H60C58.6193 42.5 57.5 41.3807 57.5 40Z",
    fill: "#000001"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 40C0 38.6193 1.11929 37.5 2.5 37.5H20C21.3807 37.5 22.5 38.6193 22.5 40C22.5 41.3807 21.3807 42.5 20 42.5H2.5C1.11929 42.5 0 41.3807 0 40Z",
    fill: "#000001"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1596 48.7501C55.8499 47.5544 57.3789 47.1447 58.5746 47.835L73.7301 56.585C74.9258 57.2754 75.3355 58.8044 74.6451 60.0001C73.9548 61.1958 72.4258 61.6055 71.2301 60.9152L56.0746 52.1652C54.8789 51.4748 54.4692 49.9458 55.1596 48.7501Z",
    fill: "#000001"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35489 20.0001C6.04524 18.8044 7.57422 18.3947 8.76995 19.085L23.9254 27.835C25.1211 28.5254 25.5308 30.0544 24.8405 31.2501C24.1501 32.4458 22.6211 32.8555 21.4254 32.1652L6.26995 23.4152C5.07422 22.7248 4.66453 21.1958 5.35489 20.0001Z",
    fill: "#000001"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7504 55.1574C49.9461 54.4671 51.4751 54.8768 52.1655 56.0725L60.9155 71.2279C61.6058 72.4237 61.1961 73.9527 60.0004 74.643C58.8047 75.3334 57.2757 74.9237 56.5854 73.7279L47.8354 58.5725C47.145 57.3768 47.5547 55.8478 48.7504 55.1574Z",
    fill: "#000001"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0004 5.35672C21.1961 4.66636 22.7251 5.07605 23.4155 6.27178L32.1655 21.4272C32.8558 22.623 32.4461 24.1519 31.2504 24.8423C30.0547 25.5326 28.5257 25.123 27.8354 23.9272L19.0854 8.77178C18.395 7.57605 18.8047 6.04707 20.0004 5.35672Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19211_77797)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#131619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerLight80);
export default __webpack_public_path__ + "static/media/spinner-light-80.435353f08a0a8f74dc126faa2f945c13.svg";
export { ForwardRef as ReactComponent };